import {FC} from 'react';

import NavLink from '~/common/NavLink/NavLink';
import CardBordered from '~/common/display/CardBordered/CardBordered';
import {Icons, PromotionIcons} from '~/common/Icon';

import s from '../styles.module.scss';
import {LinksGroupProps} from './types';

const MyAdsLinks: FC<LinksGroupProps> = ({onClickBack}) => (
  <CardBordered className={s.card}>
    <NavLink icon={Icons.myAds} label="My Ads" carretLeft onClick={onClickBack} />
    <NavLink href="/profile/dashboard" icon={Icons.adsDashboard} label="Ads Dashboard" asChild />
    <NavLink
      href="/profile/date-range-stats"
      icon={Icons.adStatistic}
      label="Ad Statistics"
      asChild
    />
    <NavLink href="/profile#/create-promotion" icon={Icons.postAd} label="Create Ad" asChild />
    <NavLink href="/profile/text-ads" icon={PromotionIcons.promoText} label="Text Ads" asChild />
{/*
    <NavLink
      icon={PromotionIcons.promoUrl}
      label="URL Promotions"
      href="/profile/url-promotions"
      asChild
    />
    <NavLink
      icon={PromotionIcons.promoMenu}
      label="Mobile menu Ads"
      href="/profile/mobile-menu-promo"
      asChild
    />
*/}
    <NavLink
      icon={PromotionIcons.promoTopspot}
      label="Top Spot Images"
      href="/profile/top-spot-promotions"
      asChild
    />
    <NavLink
      icon={PromotionIcons.promoImage}
      label="Image Promotions"
      href="/profile/image-promotions"
      asChild
    />
    <NavLink href="/profile/transactions" icon={Icons.paidInvoices} label="Transactions" asChild />
  </CardBordered>
);

export default MyAdsLinks;
